// ponytail: local drop-in for @mui/styles/withStyles.
// Same call signature: withStyles(styles)(Component) or withStyles((theme)=>styles)(Component).
import React from "react";
import { css } from "@emotion/css";
import { useTheme } from "@mui/material/styles";

// ponytail: no key transform — emotion accepts camelCase and kebab-case keys;
// transforming keys corrupts selectors ("&.Mui-selected") and media queries.
function resolveClasses(raw) {
  const classes = {};
  for (const key of Object.keys(raw)) {
    classes[key] = css(raw[key]);
  }
  return classes;
}

export default function withStyles(stylesOrFn) {
  return function withStylesHoc(Component) {
    function WithStyles(props) {
      const theme = useTheme();
      const raw =
        typeof stylesOrFn === "function" ? stylesOrFn(theme) : stylesOrFn;
      const classes = React.useMemo(() => resolveClasses(raw), [theme]);
      return <Component {...props} classes={classes} />;
    }
    WithStyles.displayName = `withStyles(${
      Component.displayName || Component.name || "Component"
    })`;
    return WithStyles;
  };
}

export { withStyles };
